import { Component, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services/index';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-trialbalance',
  templateUrl: './trialbalance.component.html',
  styleUrls: ['./trialbalance.component.css']
})
export class TrialbalanceComponent implements OnInit {

  public currentUser: any;
  public loading = false;
  public filter = { token: '', start_date: '', SHOW_ZERO_BALANCE: false }
  public data: any;
  public start_date: any;
  public total_credit: any;
  public total_debit: any;
  constructor(public fb: FormBuilder, public operationsService: OperationsService,
    public storageService: StorageService, public toastr: ToastrService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.filter.token = this.currentUser.token;
  }
  ngOnInit() {
    // this.loading = true;
    // const start_date = this.start_date;
    // return this.operationsService.loadTrialBalance(this.currentUser.token, start_date).subscribe(res => {
    //   this.loading = false;
    //   this.data = res.trial_balance;
    //   this.total_credit = res.total_credit;
    //   this.total_debit = res.total_debit;
    // }, () => {
    //   this.loading = false;
    //   this.showError('An error occurred, try again');
    // });
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  getTrialBalance() {
    this.operationsService.getTrialBalance(this.currentUser.token, this.filter).subscribe(data => {

      this.data = data

    });
  }
  loadTrialBalance() {
    const start_date = this.start_date;
    this.loading = true;
    return this.operationsService.loadTrialBalance(this.currentUser.token, start_date).subscribe(res => {
      this.loading = false;
      this.data = res.data;
    }, () => {
      this.loading = false;
      this.showError('An error occurred, try again');
    });
  }
}
